import { RouteStatus } from "@/types/route/route.common";
/**
 * Creates route data with processed route points
 * Separates validation, time calculations, and final data structure creation
 */
export async function routeFormData2CreateRouteData(formValues) {
    if (!formValues.idTechnician) {
        throw new Error("idTechnician is required");
    }
    if (!formValues.plannedStartTime) {
        throw new Error("plannedStartTime is required");
    }
    // Create final route data structure
    const routeData = {
        idTechnician: formValues.idTechnician,
        idServiceVehicle: formValues.idServiceVehicle || null,
        idChargingStation: formValues.idChargingStation || null,
        plannedStartTime: formValues.plannedStartTime?.toISOString(),
        expectedArrivalTime: formValues.expectedArrivalTime?.toISOString() || null,
        status: RouteStatus.PLANNED,
    };
    return routeData;
}
